<template>
  <v-container
    grid-list-xl
    style="height:100%; align-content:center;"
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        flex
        xs12
        sm10
        offset-xs0
        offset-sm1
        offset-lg1
      >
        <div
          class="title-preguntas-frecuentes"
          style="display:flex;"
        >
          <span :class="`${sizeTitleText} primary--text`">
            <v-icon :large="['lg','xl'].includes($vuetify.breakpoint.name)" color="primary">
              contact_support
            </v-icon>&nbsp;&nbsp;Preguntas frecuentes
          </span>
          <v-spacer />
          <v-btn
            large
            icon
            @click="$emit('emitCerrarPreguntasFrecuentes')"
          >
            <v-icon
              :large="['lg','xl'].includes($vuetify.breakpoint.name)"
              color="primary"
            >
              close
            </v-icon>
          </v-btn>
        </div>
        <br>
        <article class="hard-outlined elevation-6 pa-4 oscuro--text">
          <ul style="line-height:240%">
            <li>
              <strong class="title font-weight-bold">¿Qué es la Plataforma AJ en línea?</strong><br>
              <span class="subheading">Simplifica la gestión de tus promociones y ahorra tiempo, AJ en Línea es  una plataforma digital que permite la realización de trámites relacionados a promociones empresariales en línea. Puedes efectuar solicitudes de autorización, ampliación, modificación, desistimiento o renuncia, aclaraciones, complementaciones o enmiendas, también puedes solicitar la inclusión o exclusión de puntos de canje y presentar documentos posteriores al desarrollo o conclusión de la promoción autorizada. Crea ahora mismo tu credencial de usuario!</span>
            </li>
            <li>
              <strong class="title font-weight-bold">¿Cómo puedo acceder a la Plataforma AJ en línea?</strong><br>
              <span class="subheading">Para acceder, debes ingresar a la página web oficial y utilizar tus credenciales de usuario (nombre de usuario y contraseña) proporcionadas durante el registro. Y si no tienes credenciales asignadas, realiza tu solicitud y presenta los requisitos en linea a través del siguiente <a href="https://pajel.aj.gob.bo/Formulario/FormularioSolicitudCredenciales" target="_blank">enlace</a>.</span>
            </li>
            <li>
              <strong class="title font-weight-bold">¿Qué tipo de trámites puedo realizar en la Plataforma AJ en línea?</strong><br>
              <span class="subheading">La plataforma permite iniciar solicitudes para diversos trámites relacionados con Promociones empresariales, tales como: solicitudes de autorización de promociones empresariales, solicitudes de modificación/ampliación de promociones empresariales autorizadas, desistimiento a una solicitud de autorización, renunciar a una autorización de promoción empresarial, solicitar la aclaración/complementación/enmienda de una autorización de promoción empresarial, solicitar la inclusión y/o exclusión de puntos de canje/empresas intermediarias, y presentar documentos posteriores al desarrollo o conclusión de una promoción empresarial autorizada.</span>
            </li>
            <li>
              <strong class="title font-weight-bold">¿Cómo puedo registrar una nueva solicitud o presentación en la plataforma?</strong><br>
              <span class="subheading">Una vez dentro de la plataforma, selecciona la opción de su solicitud o presentación, completa los campos requeridos en el formulario, carga los requisitos técnicos y legales (documentos digitalizados) y sigue las instrucciones para enviar tu solicitud o presentación.</span>
            </li>
            <li>
              <strong class="title font-weight-bold">¿Es seguro realizar mis trámites a través de la Plataforma AJ en línea?</strong><br>
              <span class="subheading">Sí, la plataforma utiliza tecnología de encriptación para proteger y asegurar que todas las transacciones sean seguras para el inicio de tus trámites.</span>
            </li>
            <li>
              <strong class="title font-weight-bold">¿Puedo realizar el seguimiento de mis solicitudes en la plataforma?</strong><br>
              <span class="subheading">Sí, con el número de trámite asignado después de enviar una solicitud, puedes realizar el seguimiento del estado a través del buscador de trámites. En la misma plataforma podrás ver el progreso de tu trámite y recibir información sobre cualquier actualización del trámite.</span>
            </li>
            <li>
              <strong class="title font-weight-bold">¿Qué hago si olvido mi contraseña de acceso?</strong><br>
              <span class="subheading">Si olvidas tu contraseña, puedes utilizar la opción "¿Perdiste tú contraseña?" en la página de inicio de sesión. Se te enviarán instrucciones a tu correo electrónico para restablecerla.</span>
            </li>
            <li>
              <strong class="title font-weight-bold">¿Qué documentos necesito para iniciar una solicitud?</strong><br>
              <span class="subheading">Los documentos requeridos varían según el tipo de trámite. Al seleccionar el trámite específico, la plataforma te indicará qué documentos necesitas adjuntar para completar la solicitud.</span>
            </li>
            <li>
              <strong class="title font-weight-bold">¿Hay algún costo asociado con el uso de la Plataforma AJ en línea?</strong><br>
              <span class="subheading">Todos los trámites en la AJ sean físicos o en línea son GRATUITOS.</span>
            </li>
            <li>
              <strong class="title font-weight-bold">¿Cómo puedo contactar con soporte si tengo problemas con el uso de la plataforma?</strong><br>
              <span class="subheading">Si tienes alguna dificultad en el uso de la plataforma puedes contactarnos al número de Whatsapp <span class="font-weight-bold">"72018866"</span> o acceder a la sección "Ayuda" en la plataforma o, si te resulta más cómodo envía un correo electrónico a <a href="mailto:sistemas@aj.gob.bo">sistemas@aj.gob.bo</a>.</span>
            </li>
            <li>
              <strong class="title font-weight-bold">¿Puedo modificar una solicitud después de haberla enviado?</strong><br>
              <span class="subheading">Una vez enviada la solicitud, no puede ser modificada a menos que sea observada en la revisión legal y técnica, en ese caso tienes 24 horas para subsanar cualquier observación. Sin embargo, conforme a los plazos y requisitos de la normativa vigente para promociones empresariales, puedes desistir a una solicitud de autorización o renunciar a una autorización.</span>
            </li>
            <li>
              <strong class="title font-weight-bold">¿Cuánto tiempo tarda en procesarse una solicitud?</strong><br>
              <span class="subheading">El tiempo de procesamiento depende del tipo de trámite. Generalmente, la atención del trámite recibe respuesta en cinco (5) días hábiles después de la solicitud o presentación.  Este promedio te proporcionará una estimación del tiempo una vez que la solicitud ha sido enviada, pero para más detalles de plazos de atención se le recomienda pueda revisar la resolución regulatoria vigente para Promociones Empresariales.</span>
            </li>
            <li>
              <strong class="title font-weight-bold">¿Puedo utilizar la plataforma desde un dispositivo móvil?</strong><br>
              <span class="subheading">Sí, la Plataforma AJ en línea es compatible con dispositivos móviles, permitiéndote iniciar y gestionar solicitudes desde tu smartphone o tablet.</span>
            </li>
            <li>
              <strong class="title font-weight-bold">¿Qué hago si la plataforma no reconoce mis credenciales de acceso?</strong><br>
              <span class="subheading">Asegúrate de que estás ingresando correctamente tus credenciales de usuario (usuario y contraseña). Si el problema persiste, utiliza la opción "¿Perdiste tú contraseña?" para restablecer tu contraseña o contacta con el soporte técnico de PAJEL.</span>
            </li>
            <li>
              <strong class="title font-weight-bold">¿Es necesario contar con una firma digital para utilizar la plataforma?</strong><br>
              <span class="subheading">No, no es necesario, puedes usar la plataforma con o sin firma digital. Si quieres conocer más sobre la firma digital ingresa a <span class="font-weight-bold">"firmadigital.bo"</span>.</span>
            </li>
          </ul>
        </article>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'PreguntasFrecuentes',
  mounted() {
    window.addEventListener('keydown', this.handleEscKey);
  },
  methods: {
    handleEscKey(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        this.$emit('emitCerrarPreguntasFrecuentes');
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleEscKey);
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    sizeTitleText () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'subheading font-weight-bold'
        case 'sm': return 'headline font-weight-bold'
        case 'md': return 'headline font-weight-bold'
        case 'lg': return 'display-1 font-weight-bold'
        case 'xl': return 'display-1 font-weight-bold'
      }
    },
  },
};
</script>
<style scoped>
  @media screen and (min-width: 320px) {
    .title-preguntas-frecuentes {
      padding-top: 70px;
    }
  }
</style>
